import { Language } from '../../../enums/const-enums';

export type RassEotpErrorCodes = '922' | '924' | '998' | '999' | 'timeout';

export interface RassEotpTranslations {
  input: {
    label: string;
    error: string;
  };
  button: {
    label: {
      request: string;
      cancel: string;
    };
  };
  checkbox: {
    label: string;
  };
  instructions: {
    request: string;
    submit: string;
  };
  errors: Record<RassEotpErrorCodes, string>;
}

const nlTranslations: RassEotpTranslations = {
  input: {
    label: 'E-mailadres',
    error: 'E-mailadres bevat geen geldige waarde.',
  },
  button: {
    label: {
      request: 'Aanvragen',
      cancel: 'Annuleren',
    },
  },
  checkbox: {
    label: 'Onthouden',
  },
  instructions: {
    request: 'Vraag een eenmalig wachtwoord aan via e-mail',
    submit: 'Voer het eenmalig wachtwoord in dat is gestuurd naar ',
  },
  errors: {
    '922':
      'De toegangscode is onjuist. Controleer de toegangscode en voer deze opnieuw in.',
    '924':
      'Het maximum aantal onjuiste toegangscodes is ingevoerd. Probeer het later opnieuw.',
    '998':
      'Er is een algemene systeemfout opgetreden. Probeer het later opnieuw.',
    '999':
      'Er is een algemene systeemfout opgetreden. Probeer het later opnieuw.',
    timeout:
      'Het systeem is tijdelijk niet beschikbaar. Probeer het later opnieuw.',
  },
};

const enTranslations: RassEotpTranslations = {
  input: {
    label: 'Email address',
    error: 'Email address does not contain a valid value.',
  },
  button: {
    label: {
      request: 'Request',
      cancel: 'Cancel',
    },
  },
  checkbox: {
    label: 'Remember',
  },
  instructions: {
    request: 'Request a one-time password via email',
    submit: 'Enter the one-time password that is sent to ',
  },
  errors: {
    '922':
      'The access code is incorrect. Please check the access code and enter it again.',
    '924':
      'The maximum number of incorrect access codes has been entered. Please try again later.',
    '998': 'A system error occurred. Please try again later.',
    '999': 'A system error occurred. Please try again later.',
    timeout: 'The system is currently unavailable. Please try again later.',
  },
};

const esTranslations: RassEotpTranslations = {
  input: {
    label: 'Correo electrónico',
    error: 'Su correo electrónico contine caracteres no permitidos.',
  },
  button: {
    label: {
      request: 'Solicitar',
      cancel: 'Cancelar',
    },
  },
  checkbox: {
    label: 'Recordar',
  },
  instructions: {
    request: 'Solicita una contraseña de un solo uso por correo electrónico',
    submit: 'Introduce la contraseña de un solo uso que se envía a ',
  },
  errors: {
    '922':
      'Tu contraseña de un solo uso es incorrecta. Por favor, vuelve a intentarlo.',
    '924':
      'No es posible iniciar sesión en este momento. Por favor, vuelve a intentarlo más tarde.',
    '998':
      'Se produjo un error general del sistema. Intenta actualizar la página. Si el error persiste, por favor, vuelve a intentarlo más tarde.',
    '999':
      'Se produjo un error general del sistema. Intenta actualizar la página. Si el error persiste, por favor, vuelve a intentarlo más tarde.',
    timeout:
      'El sistema no está disponible en este momento. Por favor, vuelve a intentarlo más tarde.',
  },
};

const ptTranslations: RassEotpTranslations = {
  input: {
    label: 'E-mail',
    error: 'O endereço de e-mail não é válido.',
  },
  button: {
    label: {
      request: 'Solicitar',
      cancel: 'Cancelar',
    },
  },
  checkbox: {
    label: 'Lembrar',
  },
  instructions: {
    request: 'Solicite uma senha válida para um único acesso por e-mail',
    submit: 'Digite a senha de acesso que foi enviada para ',
  },
  errors: {
    '922': 'Sua senha única é incorreta. Por favor, tente novamente.',
    '924':
      'Não é possível iniciar sessão neste momento. Por favor, tente novamente mais tarde.',
    '998':
      'Ocorreu um erro geral no sistema. Tente recarregar a página. Se o erro persistir, por favor, tente novamente mais tarde.',
    '999':
      'Ocorreu um erro geral no sistema. Tente recarregar a página. Se o erro persistir, por favor, tente novamente mais tarde.',
    timeout:
      'O sistema está atualmente indisponível. Por favor, tente novamente mais tarde.',
  },
};

export const rassEotpTranslations = {
  [Language.NL]: nlTranslations,
  [Language.EN]: enTranslations,
  [Language.ES]: esTranslations,
  [Language.PT]: ptTranslations,
};
